import { render, staticRenderFns } from "./ModalProjects.vue?vue&type=template&id=3b818af2&lang=pug&"
import script from "./ModalProjects.vue?vue&type=script&lang=js&"
export * from "./ModalProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports